import {FEATURE_RESTRICTION_IDS} from 'helpers/constants/restrictions';

export const hasDashboardPriceControl = (serviceFeatures) =>
  !!serviceFeatures?.includes(FEATURE_RESTRICTION_IDS.MENU_PRICE_ADJUST);

// The alert comes from a scraper flag synced through HubSpot, which the Menu
// Editor's own 3PD prices replace whenever the location can edit them.
export const showScraperPricingAlert = (serviceFeatures, managePrices) =>
  !hasDashboardPriceControl(serviceFeatures) &&
  managePrices?.status === 'Disabled' &&
  !!managePrices?.priceComparisonUrl;
